import { fbt } from 'fbtee'
import { SectionHeader } from '../../../components/SectionHeader'
import { PillButton } from '../../../components/PillButton'
import { useTimeFormat } from '../../../hooks/useTimeFormat'
import { formatClockTime, type HourCycle } from '../../../lib/timeFormat'

/** Schedule settings' 12h/24h picker. Preselects the default (phone setting, else app language) until the user picks one. */
export function TimeFormatSection() {
  const { hourCycle, locale, setPref } = useTimeFormat()
  const options: Array<{ value: HourCycle; label: string }> = [
    { value: '12h', label: fbt('12-hour', 'Schedule settings option for the 12-hour clock format') },
    { value: '24h', label: fbt('24-hour', 'Schedule settings option for the 24-hour clock format') },
  ]
  return (
    <div className="space-y-2">
      <SectionHeader>
        {fbt('Time format', 'Section heading for the 12-hour/24-hour clock choice in schedule settings')}
      </SectionHeader>
      <div role="group" className="flex gap-1 rounded-full border border-border bg-card p-1 w-fit">
        {options.map(o => (
          <PillButton
            key={o.value}
            type="button"
            active={hourCycle === o.value}
            aria-pressed={hourCycle === o.value}
            data-testid={`time-format-${o.value}`}
            onClick={() => hourCycle !== o.value && setPref(o.value)}
          >
            {o.label}{' '}
            <span className="tabular-nums opacity-70">{formatClockTime('21:30', o.value, locale)}</span>
          </PillButton>
        ))}
      </div>
    </div>
  )
}
